import {
  GET_DASHBOARD_HOME,
  GET_DASHBOARD_HOME_FAILURE,
  GET_DASHBOARD_HOME_SUCCESS,
} from "./actionTypes";

const initialState = {
  dashboard: [],
  loading: false,
  error: "",
};

const stores = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_HOME:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_DASHBOARD_HOME_SUCCESS:
      state = {
        ...state,
        loading: false,
        dashboard: action.payload.statistics,
      };
      break;
    case GET_DASHBOARD_HOME_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default stores;
